import React, { useState, useEffect } from 'react';
import MetaTags from "react-meta-tags";
import { useParams, useHistory } from 'react-router-dom';
import ApiClient from '../BaseUrl/ApiClient';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';

import './UserDetail.css';

function UserDetail() {
  const [user, setUser] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { id } = useParams();
  const history = useHistory();

  const getUserDetails = async () => {
    if (!id) {
      setError('No user ID provided');
      return;
    }

    const token = localStorage.getItem('accessToken');
    if (!token) {
      setError('Please log in');
      history.push('/login');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await ApiClient.get(`/admin/user/${id}`);
      const { responseData } = response.data;
      setUser(responseData.user);
      setSubscription(responseData.subscription);
    } catch (err) {
      setError('Failed to load user details');
      if (err.response?.status === 401) {
        localStorage.removeItem('accessToken');
        history.push('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserDetails();
  }, [id]);

  const goBack = () => {
    history.push('/user-list');
  };

  return (
    <React.Fragment>
      <div className="auth-page-content custom-auth-page">
        <MetaTags>
          <title>User Detail | Findagram</title>
        </MetaTags>
        <Row>
          <Col md={12}>
            <Card>
              <CardHeader>
                <h4>User Details</h4>
              </CardHeader>
              <CardBody>
                {/* {loading && <p>Loading...</p>} */}
                {error && <p className="text-danger">{error}</p>}
                
                {user && (
                  <div className='user-detail'>
                    <Row>
  <Col md={12} className="bgcolor p-3">
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
      

      <div className="d-flex flex-column flex-sm-row">
        <div>
          <h3 className="text-dark mb-1">{user.firstName} {user.lastName}</h3>
          <p className="description mb-1">{user.email || 'Email not found'}</p>
        </div>
        {/* <div className="ms-sm-3 mt-2 mt-sm-0">
          <p className="standard mb-0">{user.userType || 'N/A'}</p>
        </div> */}
      </div>


      <div className="mt-3 mt-md-0">
        <Button color="secondary" onClick={goBack}>
          Back to List
        </Button>
      </div>

    </div>
  </Col>
</Row>


                    <Row className="mt-3">
                      <Col>
                        <div className='d-flex flex-column'>
                          {/* <p className='description'><span className='rating'>Role Type: </span>{user.roleType !== undefined ? user.roleType : 'N/A'}</p> */}
                          {/* <p className='description'><span className='rating'>User Type: </span>{user.userType || 'N/A'}</p> */}
                          {/* <p className='description'><span className='rating'>Created At: </span>{user.createdAt ? new Date(user.createdAt).toLocaleString() : 'N/A'}</p>
                          <p className='description'><span className='rating'>Updated At: </span>{user.updatedAt ? new Date(user.updatedAt).toLocaleString() : 'N/A'}</p> */}
                        </div>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col>
  <h2 className="fs-20 mb-3 fw-bold text-dark">Subscription Details</h2>
  {subscription ? (
    <div>
      <Row className="mb-2">
        <Col md={6}>
          <p className="description">
            <span className="rating">Subscription Status: </span>
       <span className="badge bg-secondary">
  {subscription.subscriptionStatus}
</span>


          </p>
        </Col>
        <Col md={6}>
         <p className="description">
            <span className="rating">Payment Method: </span>
            {subscription.subscriptionMethod || 'N/A'}
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col md={6}>
          <p className="description">
            <span className="rating">Start Date: </span>
            {subscription.subscriptionStartDate
  ? new Date(subscription.subscriptionStartDate).toLocaleDateString()
  : 'N/A'
}
          </p>
        </Col>
        <Col md={6}>
          <p className="description">
            <span className="rating">Expiry Date: </span>
            {subscription.subscriptionExpiryDate
              ? new Date(subscription.subscriptionExpiryDate).toLocaleDateString()
              : 'N/A'}
          </p>
        </Col>
      </Row>

      {/* <Row className="mb-2">
        <Col md={12}>
          <p className="description">
            <span className="rating">Payment Method: </span>
            {subscription.subscriptionMethod || 'N/A'}
          </p>
        </Col>
      </Row> */}

      {subscription.paymentCard && (
        <Row>
          <Col md={6}>
            <p className="description">
              <span className="rating">Card Brand: </span>
              {subscription.paymentCard.cardBrand || 'N/A'}
            </p>
          </Col>
          <Col md={6}>
            <p className="description">
              <span className="rating">Card Last 4 Digits: </span>
              **** **** **** {subscription.paymentCard.cardLast4Number || 'N/A'}
            </p>
          </Col>
        </Row>
      )}
    </div>
  ) : (
    <p>No subscription info</p>
  )}
</Col>

                    </Row>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default UserDetail;